export function Image({
  priority = false,
  lowPriority = false,
  alt,
  draggable = false,
  ...props
}) {
  return (
    <img
      alt={alt}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
      fetchPriority={priority ? 'high' : lowPriority ? 'low' : 'auto'}
      draggable={draggable}
      {...props}
    />
  );
}